type ContentImageMetaInput = {
  pageTitle: string;
  imageNumber: number;
};

function normalizePageTitle(value: string): string {
  const title = String(value ?? '').trim();
  return title || 'HotlistCasino';
}

function normalizeImageNumber(value: number): number {
  const n = Number(value);
  if (!Number.isFinite(n) || n < 1) return 1;
  return Math.floor(n);
}

export function getContentImageMeta({
  pageTitle,
  imageNumber,
}: ContentImageMetaInput): { title: string; alt: string } {
  const title = normalizePageTitle(pageTitle);
  const idx = normalizeImageNumber(imageNumber);
  return {
    title,
    alt: `${title} - screenshot ${idx}`,
  };
}
